














































































import Vue from 'vue'

import { useExtranetUi, ExtranetData, nanoid } from './Extranet';

export default Vue.extend({
  props: {
    editFeature: {
      type: Boolean,
      default: false
    },
    removeFeature: {
      type: Boolean,
      default: false
    },
    maxDeviceCount: {
      type: Number,
      default: 0
    },
    mode: {
      type: String,
      default: 'running'
    }
  },
  components: {
    
  },
  data() {
    return {
      selectNodeId: undefined,
      selectNodeType: undefined,
      selectNode: undefined,
      selectNodeMode: undefined,
      ui: undefined
    }
  },
  computed: {
    containerId(){
      return `ui_${nanoid()}`
    }
  },
  mounted() {
    this.ui = useExtranetUi(this.containerId);
    this.ui.removeFeature = this.removeFeature;
    this.ui.maxDeviceCount = this.maxDeviceCount;
    this.ui.beforeRemoveDevice=this.beforeRemoveDevice;
    this.ui.onSelected(this.onSelectedNode);

    const data = new ExtranetData();
    data.pc= {
      id: `pc_${nanoid()}`,
      virtualIp: '172.16.0.10'
    };
    data.gateway= {
      id: `gateway_${nanoid()}`,
      code:'网关',
      virtualIp: '172.16.0.60',
      networkDataList:[
        { name:'eht0', ip:'192.168.0.10' },
        { name:'eht1', ip:'192.168.1.10' },
        { name:'wlan0', ip:'192.168.2.238' },
      ]
    };
    this.ui.init(data);
    
  },
  created() {
  },
  destroyed() {
    this.ui?.destroy();
  },
  methods: {
    onSelectedNode(e){
      this.selectNodeType=e.type;
      this.selectNode=e.data;
      this.selectNodeMode = e.mode;
      this.selectNodeId=e.nodeId;
    },
    valueChange(key,value){
      const ipKey=[
        'virtualIp',
        'physicalIp',
      ];
      if(ipKey.findIndex(c=>c===key)>-1){
        this.ui.updateIpRepeat();
      }
      this.ui.update(this.selectNodeId, key,value);
    },
    getExtranetData(){
      return this.ui.getExtranetData();
    },
    getIpList(){
      return this.ui.findAllIpList();
    },
    updateExtranetData(data:ExtranetData){
      return this.ui.updateExtranetData(data); 
    },
    beforeRemoveDevice(name:string){

      return new Promise((res,rej)=>{
        if(!this.removeFeature){
          rej();
          return;
        }
        this.$confirm({
        title: '确认删除',
        content: `是否确认删除节点:${name}`,
        onOk: () => {
          res(true);
        },
        onCancel() {
          rej();
        },
      });
      });
    }
  },
  watch:{
    removeFeature:{
      handler(val){
        this.ui.removeFeature = val;
        this.ui.changeRemoveFeature(val);
      }
    },
    maxDeviceCount:{
      handler(val){
        this.ui.maxDeviceCount = val;
      }
    },
  }
})
